interface TrackingConfig {
  url: string;
  script: string;
  siteId: string;
}

interface Config {
  BASE_URL: string;
  API_SERVICES: string;
  TRACKING: TrackingConfig;
  YUSO_PARTNER_ID: number;
  YUSO_PARTNER_CONTACT_ID: number;
  MAINTENANCE_MV: boolean;
  DEV: boolean;
  GOOGLE_OAUTH2_CLIENT_ID: string;
}

const config: Config = {
  BASE_URL: import.meta.env.VITE_BASE_URL || 'http://localhost:3001',
  API_SERVICES: import.meta.env.VITE_API_SERVICES || 'http://localhost:8001',
  TRACKING: {
    url: import.meta.env.VITE_TRACKING_URL || 'rocket.yuso.io',
    script: import.meta.env.VITE_TRACKING_SCRIPT || 'js/',
    siteId: import.meta.env.VITE_TRACKING_SITE_ID || '1',
  },
  YUSO_PARTNER_ID: Number(import.meta.env.VITE_YUSO_PARTNER_ID) || 1,
  YUSO_PARTNER_CONTACT_ID: Number(import.meta.env.VITE_YUSO_PARTNER_CONTACT_ID) || 2389,
  MAINTENANCE_MV: import.meta.env.VITE_MAINTENANCE_MV === 'true',
  DEV: import.meta.env.VITE_DEV === 'true',
  GOOGLE_OAUTH2_CLIENT_ID:
    import.meta.env.VITE_GOOGLE_OAUTH2_CLIENT_ID ||
    '674020123718-jh44ia6kchcpqo2fg0ioptracgk1t2he.apps.googleusercontent.com',
};

console.log('Base URL:', config.BASE_URL);
console.log('Tracking URL:', config.TRACKING.url);
console.log('Partner ID:', config.YUSO_PARTNER_ID);
console.log('Dev Mode:', config.DEV);

export default config;
